import { styled } from '../jss-style';
import cardStyle from './card';

const useCardStyle = styled(cardStyle, 'card');
export { cardStyle, useCardStyle };
export default useCardStyle;
